import { Commands } from '../../../vendor_core/core/src/commands/CommandEnum';
import CommandManager from '../../../vendor_core/core/src/commands/CommandManager';
import PointerEvents from '../../../vendor_core/core/src/const/PointerEvents';
import CommManager from '../../../vendor_core/core/src/controllers/CommManager';
import AutoplayModel from '../../../vendor_core/core/src/model/AutoplayModel';
import BetModel from '../../../vendor_core/core/src/model/BetModel';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import RequestRegister from '../../../vendor_core/core/src/server/requests/RequestRegister';
import { State } from '../../../vendor_core/core/src/states/State';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIModes, UIStates } from '../../../vendor_core/core/src/ui/UIStates';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import Locale from '../../../vendor_core/core/src/utils/Locale';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import SceneView from '../../../vendor_core/core/src/views/SceneView';
import VendorModel from '../../../vendor_core/server/model/VendorModel';
import BBReelGroup from '../view/BBReelGroup';

export default class BBRelaxFreeGamesExitState extends State {
    protected scene: SceneView;
    enter(): void {
        super.enter();

        ViewManager.getLayer("PopupsBackground").setScene("open");




        let msgPatternReplace = [];

        this.scene = ViewManager.getLayer(DefaultLayers.Popups).setScene("message_box");

        this.scene.sceneTextFields.get("title").text = Locale.getString(
            "exit_free_games_title"
        );

        msgPatternReplace.push(
            BetModel.formatCurrency(
                VendorModel.freeGames.win,
                GameModel.gameConfig.defaultCurrencyFormat
            )
        );

        if (VendorModel.freeGames.win > 0) {
            this.scene.sceneTextFields.get("text").text =
                Locale.getString("gui_congratulations") +
                "\n\n" +
                Locale.getString("gui_exit_free_games_data", msgPatternReplace);
        } else {
            this.scene.sceneTextFields.get("text").text = Locale.getString(
                "gui_exit_free_games_data_loss",
                msgPatternReplace
            );
        }

        if (VendorModel.hasFreeGamesExpired) {
            let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
                .getCurrentScene()
                .getSubView("ReelGroup") as BBReelGroup;
            let reels = Array.from(Array(reelGroup.reels.length).keys());
            let result = SpinModel.getStopSymbolsForReels(reels);
            reelGroup.stop(result);

        }

        const exitButton = this.scene.buttons.get("exit");

        ViewManager.getLayer("SplashOverlay").setScene("open");

        exitButton.on(PointerEvents.DOWN, () => {
            VendorModel.exitFreeGames();
            this.cleanAutoplay();
            GameModel.shouldUpdateBalance = true;
            UIController.setMode(UIModes.DEFAULT);
            UIController.setState(UIStates.IDLE);
            CommManager.send(RequestRegister.get("hasFreeGames"), (data) => {
                // console.log(data);
                // debugger
                VendorModel.update(data);
                this.exit();
            }, this);
        });
    }

    protected cleanAutoplay() {
        AutoplayModel.setAutoSpin(0);
        CommandManager.execute(Commands.CLEAR_AUTOPLAY_LIMITS)
    }
    exit(): void {
        ViewManager.getLayer(DefaultLayers.Popups).clear();
        ViewManager.getLayer("SplashOverlay").clear();
        ViewManager.getLayer("PopupsBackground").clear();
        super.exit();
    }
}
